<template>
    <div>
        <v-data-table :headers="headers" :items="ootrucks">
            <template v-slot:top>

                <v-toolbar dense elevation="0">
                    <v-toolbar-title>Assigned trucks </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>

                    <v-combobox v-model="truck" :items="trucks" label="Add Truck" :item-text="'Truck'" :item-value="'TruckID'"
                        auto-select-first dense :append-outer-icon="'mdi-content-save-plus'"
                        @click:append-outer="addTruck"></v-combobox>
                </v-toolbar>
            </template>
            <template v-slot:item.Active="{ item }">
                <v-switch v-model="item.Active" class="mr-3" color="secondary" dense
                    style="margin-top: 0px;padding-top: 0px;" hide-details disabled>
                </v-switch>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-icon color="red" v-if="disabled" @click="deleteItem(item.OODriverTruckId)">mdi-delete</v-icon>
            </template>
        </v-data-table>
    </div>
</template>
<script>
import axios from "axios";
export default {
    props: ['ootrucks','driver'],
    data: function () {
        return {
            headers: [
                { text: 'ID', value: 'TruckID', width: '10%' },
                { text: 'Truck', value: 'Truck', width: '30%' },
                { text: 'Pump', value: 'Pump', width: '20%' },
                { text: 'Bunk', value: 'Bunk', width: '20%' },
                { text: 'Active', value: 'Active', width: '15%' },
                {
                    text: 'Delete',
                    value: 'actions',
                    sortable: false,
                    width: '5%'
                },
            ],
            trucks: [],
            truck: [],
            disabled:false
        }
    },
    mounted() {
        if(this.$store.state.roles == 'CardingAgent' || this.$store.state.roles == 'Human Resources' || this.$store.state.roles == 'Administrator'){
            this.disabled =true;
        }
        this.loadTrucks();
    },
    methods: {

        deleteItem: function (id) {
            var r = confirm('Are you sure you want to delete?');
            if (r) {
                this.deleteTruck(id);
            } else {
                confirm('Canceled');
            }
        },
        loadTrucks: function () {
            this.$store.state.isLoading = true;
            axios
                .get('truck/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    this.trucks = response.data;
                    this.$store.state.isLoading = false;
                })
                .catch(error => {
                    this.$store.state.isLoading = false;
                    console.log(error);
                });
        },
        deleteTruck: function (id) {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .delete('oo-truck/' + id, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    this.ootrucks = response.data.oo_trucks;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        addTruck: function () {
            var parms = {
                Driver :this.driver,
                Truck: this.truck.TruckID,
            }
            axios
                .post('oo-truck', parms,{
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    this.ootrucks = response.data;
                    this.$store.state.isLoading = false;
                })
                .catch(error => {
                    this.$store.state.isLoading = false;
                    console.log(error);
                });
        }
    }
}
</script>